import {Button, Tag} from "antd";
import LogRowMenu from "./LogRowMenu";
import {EyeOutlined} from "@ant-design/icons";

export default function logColumns(t, onViewJson)
{
    return [
        {
            title: t('Id'),
            dataIndex: 'id',
            key: 'id',
            columnName: 'id',
            width: 120,
            render: (text, record) => (
                <LogRowMenu row={record} />
            )
        },
        {
            title: t('Date'),
            dataIndex: 'createdDate',
            key: 'createdDate',
            columnName: 'createdDate',
            width: 180,
            render: (text) => text ? new Date(text).toLocaleString() : '-',
        },
        {
            title: t('Log Name'),
            dataIndex: 'logName',
            key: 'logName',
            columnName: 'logName',
            width: 120,
            render: (text) => (
                <Tag color="blue">{text}</Tag>
            )
        },
        {
            title: t('Log Type'),
            dataIndex: 'logType',
            key: 'logType',
            columnName: 'logType',
            width: 150,
        },
        {
            title: t('User'),
            dataIndex: 'userId',
            key: 'userId',
            columnName: 'userId',
            width: 150,
        },
        {
            title: t('Primary Key'),
            dataIndex: 'primaryKey',
            key: 'primaryKey',
            columnName: 'primaryKey',
            width: 120,
        },
        {
            title: t('Description'),
            dataIndex: 'description',
            key: 'description',
            columnName: 'description',
            ellipsis: true,
        },
        {
            title: t('Data'),
            dataIndex: 'jsonData',
            key: 'jsonData',
            columnName: 'jsonData',
            width: 80,
            render: (data, record) => {
                if (!data) return '-';
                return (
                    <Button 
                        size="small" 
                        icon={<EyeOutlined />}
                        onClick={() => onViewJson && onViewJson(data)}
                    />
                )
            }
        },
    ]
}
